import { render } from "./PrepSummaryTray.vue?vue&type=template&id=2540c370&scoped=true"
import script from "./PrepSummaryTray.vue?vue&type=script&lang=js"
export * from "./PrepSummaryTray.vue?vue&type=script&lang=js"

import "./PrepSummaryTray.vue?vue&type=style&index=0&id=2540c370&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2540c370"]])

export default __exports__